import type { FunctionComponent } from "react";

import { Container, Number, Wrapper } from "./styles";

export type Props = {
  className?: string;
  number?: number | string;
};

export const MyDailyFiveNumber: FunctionComponent<Props> = ({ className, number }) => (
  <Container className={className}>
    <Wrapper>
      <Number>{number}</Number>
    </Wrapper>
  </Container>
);

MyDailyFiveNumber.displayName = "MyDailyFiveNumber";
